module.exports = __webpack_public_path__ + "static/media/paypal_logo.3917c3c9.png";